export function getParamFromUrl(param) {
  const url = new URL(window.location.href)

  const urlParamValue = url.searchParams.get(param)
  if (urlParamValue) return urlParamValue

  const redirectUrl = url.searchParams.get('redirect_url')
  if (!redirectUrl) return ''

  try {
    return new URL(decodeURIComponent(redirectUrl)).searchParams.get(param) || ''
  } catch (e) {
    console.warn('getParamFromUrl: failed to parse redirect_url', redirectUrl, e)
    return ''
  }
}
